/**
 * APP 商城容器 query
 * 仅在 App 首页（/pages/app-store）将 URL 上全部 query 写入 sessionStorage；
 * 其它页面只读 session，不修改链接、不拦截跳转。
 *
 * 用法：
 *   window.rrMallContainerQuery.getPersistedQuery()
 *   window.rrMallContainerQuery.navigateAppHomeResetHistory('/pages/app-store')
 */
(function (global) {
  'use strict';

  var STORAGE_KEY = '__rr_mall_container_query__';
  var HOME_RESET_FLAG = '__rr_mall_home_history_reset__';
  /** 协议常用字段（业务可读；session 内可能还有其它 key） */
  var CORE_KEYS = ['id', 'type', 'apilevel'];
  var APP_HOME_PATH_RE = /\/pages\/app-store$/i;

  function isAppWebView() {
    return (
      typeof global.__rrMallIsAppWebView__ === 'function' &&
      global.__rrMallIsAppWebView__(global.navigator && global.navigator.userAgent)
    );
  }

  function isAppHomePage() {
    var path = (global.location && global.location.pathname) || '';
    return APP_HOME_PATH_RE.test(path.replace(/\/$/, '') || path);
  }

  /** 读取 search 上全部 query（非仅 CORE_KEYS） */
  function readAllFromSearch(search) {
    var out = {};
    try {
      var params = new URLSearchParams(search || global.location.search);
      params.forEach(function (val, key) {
        if (key && val != null && val !== '') {
          out[key] = val;
        }
      });
    } catch (e) {}
    return out;
  }

  function saveToStorage(query) {
    if (!query || Object.keys(query).length === 0) return;
    try {
      global.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(query));
    } catch (e) {}
  }

  function loadFromStorage() {
    try {
      var raw = global.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function hasQueryParams(query) {
    return query && Object.keys(query).length > 0;
  }

  /** 首页：URL 有任意 query 时整包写入 session 并返回；其它页：只读 session */
  function getPersistedQuery() {
    if (isAppWebView() && isAppHomePage()) {
      var fromUrl = readAllFromSearch();
      if (hasQueryParams(fromUrl)) {
        saveToStorage(fromUrl);
        return fromUrl;
      }
    }
    return loadFromStorage();
  }

  /** 仅在 App 首页：把当前 URL 全部 query 写入 session */
  function syncFromCurrentLocation() {
    if (!isAppWebView() || !isAppHomePage()) return;
    var fromUrl = readAllFromSearch();
    if (hasQueryParams(fromUrl)) saveToStorage(fromUrl);
  }

  /**
   * 跳转 App 商城首页并尽量清空 WebView 历史栈（replace + 回首页后再 replaceState）
   * @param {string} homeUrl 一般为 /pages/app-store 完整 URL
   */
  function navigateAppHomeResetHistory(homeUrl) {
    if (!homeUrl) return;
    try {
      global.sessionStorage.setItem(HOME_RESET_FLAG, '1');
    } catch (e) {}

    try {
      if (global.history.length > 1) {
        global.history.go(1 - global.history.length);
        global.setTimeout(function () {
          global.location.replace(homeUrl);
        }, 0);
        return;
      }
    } catch (e) {}

    global.location.replace(homeUrl);
  }

  /** 落地首页后执行一次，配合 navigateAppHomeResetHistory */
  function applyHomeHistoryReset() {
    if (!isAppWebView() || !isAppHomePage()) return;
    try {
      if (global.sessionStorage.getItem(HOME_RESET_FLAG) !== '1') return;
      global.sessionStorage.removeItem(HOME_RESET_FLAG);
      if (global.history.replaceState) {
        global.history.replaceState(null, '', global.location.href);
      }
      if (global.history.length > 1) {
        global.history.go(1 - global.history.length);
        global.setTimeout(function () {
          try {
            if (global.history.replaceState) {
              global.history.replaceState(null, '', global.location.href);
            }
          } catch (e2) {}
        }, 0);
      }
    } catch (e) {}
  }

  var rrMallContainerQuery = {
    CORE_KEYS: CORE_KEYS.slice(),
    KEYS: CORE_KEYS.slice(),
    STORAGE_KEY: STORAGE_KEY,
    isAppWebView: isAppWebView,
    isAppHomePage: isAppHomePage,
    getPersistedQuery: getPersistedQuery,
    syncFromCurrentLocation: syncFromCurrentLocation,
    loadFromStorage: loadFromStorage,
    readAllFromSearch: readAllFromSearch,
    navigateAppHomeResetHistory: navigateAppHomeResetHistory,
    applyHomeHistoryReset: applyHomeHistoryReset,
  };

  global.rrMallContainerQuery = rrMallContainerQuery;

  if (isAppWebView()) {
    syncFromCurrentLocation();
    applyHomeHistoryReset();
  }
})(typeof window !== 'undefined' ? window : this);
